import { render, staticRenderFns } from "./CardBriefApprovla.vue?vue&type=template&id=66863317&scoped=true&"
import script from "./CardBriefApprovla.vue?vue&type=script&lang=js&"
export * from "./CardBriefApprovla.vue?vue&type=script&lang=js&"
import style0 from "./CardBriefApprovla.vue?vue&type=style&index=0&id=66863317&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66863317",
  null
  
)

export default component.exports